import { Fragment, useState } from 'react'
import { set } from 'lodash'

import './hotel-guest-select.scss'
import Counter from '../Counter'

const HotelGuestSelect = ({
  initialValues,
  handleSubmit,
  handleCancel,
  maxGuests,
}) => {
  const [rooms, setRooms] = useState([...initialValues])
  const submit = () => {
    handleSubmit(rooms)
  }
  const totalGuests = rooms.reduce(
    (num, { adults, children }) => num + adults + children,
    0,
  )

  return (
    <div className="hotel-guest-select">
      {rooms.map((room, index) => {
        const roomTotal = room.adults + room.children
        return (
          <Fragment key={index}>
            <div className="hotel-room-header">
              <p className="unit-count">Unit {index + 1}</p>
              {rooms?.length > 1 ? (
                <div className="remove-room">
                  <button
                    onClick={() => {
                      const current = [...rooms]
                      current.splice(index, 1)
                      setRooms(current)
                    }}
                  >
                    Remove
                  </button>
                </div>
              ) : null}
            </div>
            <div className="row">
              <p className="label">Adults</p>
              <div className="guest-counter">
                <Counter
                  count={room.adults}
                  handleChange={val => {
                    const current = [...rooms]
                    set(current, [index, 'adults'], val)
                    setRooms(current)
                  }}
                  disAbleDecrement={room.adults <= 1}
                  disableIncrement={
                    roomTotal >= maxGuests || totalGuests >= maxGuests
                  }
                />
              </div>
            </div>
            <div className="row">
              <p className="label">Children</p>
              <div className="guest-counter">
                <Counter
                  count={room.children}
                  handleChange={val => {
                    const current = [...rooms]
                    set(current, [index, 'children'], val)
                    setRooms(current)
                  }}
                  disAbleDecrement={room.children <= 0}
                  disableIncrement={
                    roomTotal >= maxGuests || totalGuests >= maxGuests
                  }
                />
              </div>
            </div>
          </Fragment>
        )
      })}
      <button
        className="hotel-guest-add-room"
        onClick={() => {
          setRooms([...rooms, { adults: 1, children: 0 }])
        }}
        disabled={totalGuests >= maxGuests}
      >
        + Add Unit
      </button>
      <div className="hotel-guest-select-footer">
        <button onClick={handleCancel} className="cancel-btn btn" type="button">
          Cancel
        </button>
        <button onClick={submit} className="btn-primary btn" type="button">
          Done
        </button>
      </div>
    </div>
  )
}

export default HotelGuestSelect
